import './title-style.scss'

import classNames from 'classnames'
import React from 'react'

const Title = ({ title, noLine }) => (
  <div
    className={classNames({
      'title-container': true,
      'no-line': noLine,
    })}
  >
    <h2>{title}</h2>
  </div>
)

export default Title
